import { render, staticRenderFns } from "./DashboardAgendamientosEstudiantes.vue?vue&type=template&id=52782f62&"
import script from "./DashboardAgendamientosEstudiantes.vue?vue&type=script&lang=js&"
export * from "./DashboardAgendamientosEstudiantes.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAgendamientosEstudiantes.vue?vue&type=style&index=0&id=52782f62&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports